<div class="row g-3 ">
	<!-- User Info Card -->
	<app-property-overview-widget class="col-12 col-md-3"></app-property-overview-widget>

	<!-- New Work Request Form Card -->
	<div class="col-12 col-md-9">
		<div class="card h-100">
			<div class="card-body">
				<h5 class="card-title">{{ContentStrings['RequestWorkOrder'][language]}}</h5>
				<div class="row">
					<div class="col-12 col-md-4 mb-3">
						<div class="row">
							<!--<div class="col-12 mb-3">
								<label for="workType" class="form-label">Reason For Request</label>
								<select id="workType" class="form-select" (change)="onReasonForRequestChange($event)" name="workType" >
									<option value="" disabled selected>Select work type</option>
									<option *ngFor="let type of _wr.ReasonRequests(); let i = index" [value]="i">{{ type.LABEL }}</option>
								</select>
							</div>-->

							<div class="col-12 mb-3">
								<label for="workType" class="form-label"><i [title]="ContentStrings['RequiredField'][language]" class="fa-solid fa-asterisk required"></i> {{ContentStrings['ReportedArea'][language]}}</label>
								<select id="workType" class="form-select" (change)="onReportedAreaChange($event)" name="workType" >
									<option value="" disabled selected>{{ContentStrings['SelectReportedArea'][language]}}</option>
									<option *ngFor="let loc of _wr.ReportedLocations(); let i = index" [value]="i">{{ loc.LABEL }}</option>
								</select>
							</div>

							<div class="col-12 mb-3">
								<label for="workType" class="form-label"><i [title]="ContentStrings['RequiredField'][language]" class="fa-solid fa-asterisk required"></i> {{ContentStrings['JobLocation'][language]}}</label>
								<select id="workType" class="form-select" (change)="onJobLocationChange($event)" name="workType" >
									<option value="" disabled selected>{{ContentStrings['SelectJobLocation'][language]}}</option>
									<option *ngFor="let loc of filteredJobLocations; let i = index" [value]="i">{{ loc.LABEL }}</option>
								</select>
							</div>

							<div class="col-12 mb-3">
								<label for="description" class="form-label"><i [title]="ContentStrings['RequiredField'][language]" class="fa-solid fa-asterisk required"></i> {{ContentStrings['Description'][language]}}</label>
								<textarea id="description" class="form-control" (change)="onDescriptionChange($event)" name="description" rows="4" [(ngModel)]="formDescription"></textarea>
							</div>

							<div class="col-12 mb-3">
								<label for="emergency" class="form-label">{{ContentStrings['Emergency'][language]}}</label>
								<div>
									<span>
										<input type="checkbox" id="emergency" class="form-check-input" (change)="onEmergencyChange($event)" name="emergency" [(ngModel)]="isEmergency"/>
									</span>
									<span>
										{{ContentStrings['EmergencyCheckText'][language]}}
									</span>
								</div>
							</div>
							<div class="col-12 mb-3">
								<label class="form-label">{{ContentStrings['AddPhoto'][language]}}</label>
								<div class="nativeFileUploader">
									<input #fileInput type="file" accept="image/*" multiple (change)="onFileChange($event)" name="photos" style="display: none;" />
									<button type="button" class="btn btn-secondary" (click)="fileInput.click()" style="width: 100%;">
										<i class="fa fa-upload"></i> {{ContentStrings['ChooseFiles'][language]}}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-8 mb-3">

						<label class="form-label">{{ContentStrings['AttachedImages'][language]}}</label>

						<div class="row selected-images" >
							<div *ngIf="_wr.newRequestImages().length === 0">{{ContentStrings['NoImagesUploaded'][language]}}</div>
							<div *ngFor="let file of _wr.newRequestImages(); let i = index" class="col-12 col-md-4 imagePreviewContainer mb-4">
								<div class="photocontainer">
									<div style="text-transform:uppercase">
										
										<div style="display: flex; margin-bottom:4px;" (click)="removeFile(i)">
											<div class="removeBtn" style="margin-right: 4px;">
												<i class="fa fa-times" aria-hidden="true"></i>
											</div>
											<div class="ellipsis">
												{{ file.name }}
											</div>
										</div>
									</div>
									<div *ngIf="file.type.startsWith('image/')" style="text-align: center;">
										<img [src]="getImageUrl(file)" alt="Preview" style="max-width: 100%;" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 mb-3">
						
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-4 mb-3">
						<button (click)="submitRequest()" class="btn btn-primary" style="width:100%" 
						[disabled]="_wr.newRequest().Job_location_id == 0 
						|| _wr.newRequest().Reported_location_id == 0 
						|| _wr.newRequest().Description.trim().length == 0">{{ContentStrings['SubmitRequest'][language]}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>